import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { useApiSDK } from '../../../contexts/apiSdkContext';
import { AppContext } from '../../../pages/layout';

type TDeviceDeleteImportHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, string, unknown>['mutate'];
};

function useDeleteDeviceImport(): TDeviceDeleteImportHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => {
      return sdk.devices.delete_import(id);
    },
    onSuccess: async (_contexts) => {
      await queryClient.invalidateQueries(['device-imports']);
      await queryClient.invalidateQueries(['device-import']);
      appContext?.crudAlert('delete', 'device import', 'm');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeleteDeviceImport };
